import * as React from "react";

function SvgGraph(props) {
  return (
    <svg width={32} height={32} fill="none" viewBox="0 0 32 32" {...props}>
      <path
        fill="#24CC85"
        d="M28.5714 0H3.42857C1.53571 0 0 1.53571 0 3.42857V28.5714C0 30.4643 1.53571 32 3.42857 32H28.5714C30.4643 32 32 30.4643 32 28.5714V3.42857C32 1.53571 30.4643 0 28.5714 0ZM11.4286 24C11.4286 24.6314 10.9171 25.1429 10.2857 25.1429H8C7.36857 25.1429 6.85714 24.6314 6.85714 24V14.8571C6.85714 14.2257 7.36857 13.7143 8 13.7143H10.2857C10.9171 13.7143 11.4286 14.2257 11.4286 14.8571V24ZM18.2857 24C18.2857 24.6314 17.7743 25.1429 17.1429 25.1429H14.8571C14.2257 25.1429 13.7143 24.6314 13.7143 24V8C13.7143 7.36857 14.2257 6.85714 14.8571 6.85714H17.1429C17.7743 6.85714 18.2857 7.36857 18.2857 8V24ZM25.1429 24C25.1429 24.6314 24.6314 25.1429 24 25.1429H21.7143C21.0829 25.1429 20.5714 24.6314 20.5714 24V19.4286C20.5714 18.7971 21.0829 18.2857 21.7143 18.2857H24C24.6314 18.2857 25.1429 18.7971 25.1429 19.4286V24Z"
      />
    </svg>
  );
}

export default SvgGraph;
